import { render, staticRenderFns } from "./BallotsAndMandates.vue?vue&type=template&id=4a310ddf&"
import script from "./BallotsAndMandates.vue?vue&type=script&lang=js&"
export * from "./BallotsAndMandates.vue?vue&type=script&lang=js&"
import style0 from "./BallotsAndMandates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports